export default __webpack_public_path__ + "static/media/arrow-right.6a792465.svg";